module.exports = __webpack_public_path__ + "static/img/pic2.a88ea1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/update/pic2.png
// module id = 5KLw
// module chunks = 13 14